// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BespokeId/index.css
// module id = 3113
// module chunks = 0